import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M3347 6174 c-16 -5 -17 -48 -15 -762 l3 -757 145 0 145 0 3 749 c1
440 -2 754 -7 759 -10 10 -245 19 -274 11z"/>
<path d="M9296 5934 c-3 -9 -6 -51 -6 -95 l0 -79 -50 0 c-61 0 -62 -2 -58
-155 l3 -110 50 -5 50 -5 5 -340 5 -340 26 -40 c15 -22 35 -48 46 -57 49 -45
207 -88 319 -88 66 0 66 1 62 155 l-3 110 -73 3 c-45 2 -75 7 -77 15 -10 28
-11 567 -1 577 5 5 40 10 77 10 61 0 67 2 73 23 11 42 7 222 -6 235 -7 7 -40
12 -79 12 -79 0 -79 0 -79 111 l0 79 -139 0 c-117 0 -140 -2 -145 -16z"/>
<path d="M1060 5778 c1 -17 11 -63 49 -228 35 -155 81 -357 140 -615 23 -99
47 -202 54 -230 l13 -50 142 -3 c140 -3 142 -2 152 20 5 13 28 96 49 186 43
176 45 182 66 182 14 0 26 -32 44 -121 5 -24 17 -75 26 -114 9 -38 19 -85 22
-102 3 -18 11 -37 18 -43 8 -7 65 -10 151 -8 l139 3 38 155 c20 85 51 214 68
285 34 146 82 345 128 540 17 72 31 136 31 143 0 9 -36 12 -145 12 -171 0
-152 17 -185 -165 -42 -231 -60 -295 -80 -295 -23 0 -27 13 -70 245 -18 94
-36 180 -41 193 -8 21 -13 22 -148 22 -124 0 -140 -2 -145 -17 -3 -10 -24
-110 -46 -223 -23 -112 -44 -208 -46 -212 -7 -11 -32 -10 -38 1 -5 8 -69 332
-81 414 l-6 37 -149 0 c-114 0 -150 -3 -150 -12z"/>
<path d="M2741 5770 c-39 -8 -115 -47 -161 -83 -34 -26 -91 -113 -105 -160
-20 -69 -20 -143 1 -151 22 -9 237 -7 250 2 5 4 18 28 28 55 21 55 38 67 98
67 59 0 93 -35 103 -105 l6 -51 -102 4 c-165 7 -246 -20 -327 -110 -54 -60
-89 -124 -108 -200 -14 -58 -14 -75 -4 -120 19 -77 45 -122 102 -173 88 -79
222 -126 313 -110 22 4 123 10 225 14 l185 6 0 425 0 425 -25 50 c-44 89 -102
147 -187 187 -52 25 -78 30 -155 33 -51 2 -113 0 -137 -5z m160 -677 c65 -39
72 -124 14 -169 -74 -56 -215 -10 -215 70 1 84 123 145 201 99z"/>
<path d="M4445 5769 c-104 -24 -228 -126 -254 -209 -8 -25 -18 -50 -23 -56 -5
-6 -9 -141 -9 -299 l-1 -287 36 -73 c83 -168 251 -243 459 -205 107 20 210 99
263 201 27 51 29 61 29 184 l0 130 -140 0 -140 0 -7 -94 c-4 -55 -14 -103 -22
-116 -30 -45 -115 -44 -157 1 -24 25 -24 29 -27 254 -3 246 2 275 50 301 27
15 94 5 118 -16 20 -18 38 -89 42 -170 l3 -50 144 -3 143 -3 -3 123 c-4 112
-7 128 -33 183 -49 99 -143 176 -251 204 -48 13 -164 13 -220 0z"/>
<path d="M5257 5769 c-100 -20 -217 -123 -259 -229 -20 -50 -22 -76 -26 -306
-3 -206 -1 -263 12 -314 50 -195 217 -304 436 -286 138 11 259 94 318 216 l27
55 0 300 0 300 -29 57 c-87 172 -263 248 -479 207z m183 -287 c38 -38 43 -82
38 -312 -3 -172 -6 -192 -24 -217 -29 -39 -84 -52 -129 -30 -52 25 -57 57 -53
315 l3 224 28 24 c41 35 99 33 137 -4z"/>
<path d="M7797 5765 c-95 -26 -191 -109 -236 -204 l-26 -56 0 -305 0 -305 29
-55 c54 -103 156 -180 265 -200 154 -29 284 6 381 100 68 66 102 138 108 228
l5 72 -141 0 -141 0 -11 -42 c-18 -72 -30 -88 -64 -88 -89 0 -146 46 -146 118
l0 32 249 0 249 0 3 23 c2 12 1 114 -2 227 -6 238 -14 264 -103 353 -57 57
-117 91 -186 107 -62 13 -175 11 -233 -5z m171 -266 c40 -14 64 -64 60 -127
l-3 -47 -100 0 -100 0 -3 34 c-11 116 49 174 146 140z"/>
<path d="M8654 5770 c-107 -22 -211 -106 -261 -209 l-28 -56 0 -300 0 -300 27
-55 c38 -77 109 -147 188 -184 60 -29 73 -31 175 -30 133 0 193 20 273 90 95
83 135 188 130 342 l-3 87 -141 3 c-165 3 -154 11 -154 -119 0 -68 -3 -78 -25
-99 -20 -18 -37 -24 -75 -24 -96 0 -110 39 -110 295 0 195 8 247 42 279 44 41
137 16 157 -41 6 -18 11 -62 11 -98 0 -36 4 -72 8 -79 7 -9 43 -12 148 -10
l139 3 -1 105 c0 127 -18 188 -77 263 -50 64 -57 69 -134 108 -54 26 -77 31
-155 34 -51 2 -112 0 -134 -5z"/>
<path d="M6301 5751 c-212 -79 -349 -303 -311 -508 22 -124 59 -257 78 -282
48 -65 145 -62 191 5 27 40 26 81 -8 228 -34 146 -24 205 43 272 74 75 195 84
279 21 53 -40 71 -79 103 -209 33 -138 39 -152 80 -171 69 -34 140 -11 169 53
18 39 17 41 -14 176 -37 159 -64 217 -133 290 -94 100 -172 134 -318 140 -88
4 -114 1 -159 -15z"/>
<path d="M7026 5479 c-50 -43 -53 -77 -22 -214 40 -176 34 -234 -34 -303 -41
-43 -86 -62 -152 -63 -65 -1 -113 19 -154 63 -43 45 -48 56 -79 193 -24 104
-32 124 -59 147 -25 22 -41 28 -79 28 -42 0 -54 -5 -82 -33 -44 -44 -51 -76
-32 -140 8 -29 25 -92 36 -141 13 -54 33 -109 53 -140 161 -259 502 -302 714
-91 68 67 105 131 128 222 23 87 20 124 -20 293 -38 156 -50 181 -102 201 -44
17 -80 10 -116 -22z"/>
<path d="M3700 5265 l0 -135 203 2 202 3 0 130 0 130 -202 3 -203 2 0 -135z"/>
<path d="M5826 5278 c-20 -29 -20 -52 0 -72 21 -21 57 -20 77 2 24 26 21 47
-9 71 -34 27 -49 26 -68 -1z"/>
<path d="M7343 5285 c-43 -30 -20 -95 32 -95 15 0 31 10 41 26 16 24 16 27 -3
52 -25 33 -41 37 -70 17z"/>
<path d="M5871 5076 c-20 -23 -9 -69 18 -83 29 -14 55 -4 71 28 26 47 -55 96
-89 55z"/>
<path d="M7380 5071 c-23 -44 -5 -81 40 -81 14 0 31 5 38 12 7 7 12 24 12 38
0 14 -5 31 -12 38 -19 19 -66 15 -78 -7z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
